import {Component, OnInit} from '@angular/core';

@Component({
    selector: 'app-firm-vendcard',
    templateUrl: './firm-vendcard.component.html',
    styleUrls: ['./firm-vendcard.component.css']
})
export class FirmVendcardComponent implements OnInit {
    public firm: any;
    public searchText;

    constructor() {
    }

    ngOnInit() {
        this.firm = localStorage.getItem('firm');
    }

}



// WEBPACK FOOTER //
// /home/escobar/Documents/Projects/E-VEND/Srl-Evend/FE/superadmin/src/app/firm-vendcard/firm-vendcard.component.ts